import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { EditorBookingItem } from '../editor-booking-item/editor-booking-item.model';


@Component({
    selector: 'eas-editor-booking-item-booking-form',
    templateUrl: './editor-booking-item-booking-form.component.html',
    styleUrls: ['./editor-booking-item-booking-form.component.css'],
    standalone: false
})
export class EditorBookingItemBookingFormComponent implements OnInit, OnDestroy {
  @Input() replacingItem: EditorBookingItem;
  @Input() parentFormGroup: FormGroup;
  @Input() itemCanBeBookedForm: FormControl;
  @Input() itemHideSpecificBookingSettingsForm: FormControl;

  private destroyed$ = new Subject<void>();

  userSetHideSpecificBookingSettings: boolean;

  constructor() {

  }

  ngOnInit() {
    this.userSetHideSpecificBookingSettings = this.itemHideSpecificBookingSettingsForm.value;

    if (this.itemCanBeBookedForm.disabled || !this.itemCanBeBookedForm.value) {
      this.itemHideSpecificBookingSettingsForm.reset(false);
      this.itemHideSpecificBookingSettingsForm.disable();
    }

    this.itemCanBeBookedForm.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(canBeBookedFormValue => {
        if (canBeBookedFormValue) {
          this.itemHideSpecificBookingSettingsForm.setValue(this.userSetHideSpecificBookingSettings);
          this.itemHideSpecificBookingSettingsForm.enable();
        } else {
          this.userSetHideSpecificBookingSettings = this.itemHideSpecificBookingSettingsForm.value;
          this.itemHideSpecificBookingSettingsForm.reset(false);
          this.itemHideSpecificBookingSettingsForm.disable();
        }
      });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
